export default {
  'pages.intention.title': '意向单列表',
  'pages.intention.search.id': '意向单编号',
  'pages.intention.search.id.placeholder': '请输入编号查询',
  'pages.intention.search.name': '商品名称',
  'pages.intention.search.name.placeholder': '请输入商品名称或商品编码查询',
  'pages.intention.search.date': '下单时间',
  'pages.intention.search.date.placeholder1': '请选择开始时间',
  'pages.intention.search.date.placeholder2': '请选择结束时间',
  'pages.intention.header.info': '商品信息',
  'pages.intention.header.craft': '定制工艺',
  'pages.intention.header.color': '配件颜色',
  'pages.intention.header.quantity': '数量',
  'pages.intention.list.id': '意向单编号',
  'pages.intention.list.date': '下单时间',
  'pages.intention.list.person': '下单人',
  'pages.intention.search.status': '意向单状态',
  'pages.intention.search.status.placeholder': '请选择意向单状态',
  'pages.intention.header.action': '操作',
};
